import { IconImage } from 'bold-ui'
import { PinosTerritorioQuery, PoligonosTerritorioQuery, TerritorioMapaImovelQuery } from 'graphql/types.generated'

import { TerritorioMapaBuscaFormModel } from './mapa-busca/model-territorioMapaBusca'

export const MAPA_DO_TERRITORIO_ROUTE = 'mapa-do-territorio'

export const PINO_TERRITORIO_MODAL_ROUTE = 'pino'

export const FILTROS_AVANCADOS_MODAL_ROUTE = 'filtros-avancados'

export type TerritorioCamadaQueryModel = PoligonosTerritorioQuery['poligonosTerritorio'][number]

export type TerritorioPinoQueryModel = PinosTerritorioQuery['pinosTerritorio']

export type TerritorioPinoModel = TerritorioPinoQueryModel['content'][number]

export type TerritorioPinoComCoordenadas = TerritorioPinoModel & { latitude: number; longitude: number }

export type TerritorioMapaImovelModel = NonNullable<TerritorioMapaImovelQuery['imovel']>

export type TerritorioMapaFamiliaResidenteModel = TerritorioMapaImovelModel['familias'][number]

export type TerritorioMapaCacheModel = {
  filter: TerritorioMapaBuscaFormModel
  lastUpdated: number
}

export enum MapaSidebarNavItemEnum {
  BUSCA = 'BUSCA',
  CAMADAS = 'CAMADAS',
  AJUDA = 'AJUDA',
}

export const MAPA_SIDEBAR_NAV_ITEMS: Record<MapaSidebarNavItemEnum, { label: string; icon: IconImage }> = {
  [MapaSidebarNavItemEnum.BUSCA]: {
    label: 'Busca',
    icon: 'zoomOutline',
  },
  [MapaSidebarNavItemEnum.CAMADAS]: {
    label: 'Camadas',
    icon: 'mapOutline',
  },
  [MapaSidebarNavItemEnum.AJUDA]: {
    label: 'Ajuda',
    icon: 'questionMarkOutline',
  },
}

export const MAPA_SIDEBAR_NAV_ITEM_ROUTE: Record<MapaSidebarNavItemEnum, string> = {
  [MapaSidebarNavItemEnum.BUSCA]: 'busca',
  [MapaSidebarNavItemEnum.CAMADAS]: 'camadas',
  [MapaSidebarNavItemEnum.AJUDA]: 'ajuda',
}
